import Api from "@/api/api";
import {CustomerContext} from "@/contexts";
import {ICoach} from "@/interfaces/interface";
import {Form, ImageFromAssets, ItemContainer} from "@/shared/";
import {useContext, useState} from "react";
import "./NewRequestHeader.scss";

type Props = {
  coachesByStatus: ICoach[];
};

export function NewRequestHeader({coachesByStatus}: Props) {
  const [loading, setLoading] = useState<boolean>(false);

  const {getCustomerData} = useContext(CustomerContext);

  const handleApproveAllClick = async () => {
    try {
      setLoading(true);

      const res = await Api.post(`admin/customers/coaches/approve/bulk`, {
        coachUsernames: coachesByStatus.map((coach) => coach.username),
      });
      if (res.status === 200) {
        await getCustomerData();
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const approveAllVisible = coachesByStatus.length > 0;

  return (
    <ItemContainer.Header
      className="new-request-header"
      leftSide={<div>New Requests</div>}
      rightSide={
        <Form.Button
          loading={loading}
          // hidden={!approveAllVisible}
          hidden={true}
          onClick={handleApproveAllClick}
        >
          <ImageFromAssets name="user-approve.svg"/>
          APPROVE ALL
        </Form.Button>
      }
    />
  );
}
